import { render, staticRenderFns } from "./MostOccurringRow.vue?vue&type=template&id=9f41a622&"
import script from "./MostOccurringRow.vue?vue&type=script&lang=js&"
export * from "./MostOccurringRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports